module.exports = __webpack_public_path__ + "img/shengri.271a8fd6.png";